import React from "react";

const testimonials = [
  {
    name: "Purvanshi Chouhan",
    position: "CEO, Example Inc.",
    image:
      "https://media.istockphoto.com/id/1354842602/photo/portrait-of-a-young-businesswoman-working-on-a-laptop-in-an-office.jpg?s=612x612&w=0&k=20&c=kfP1g2712RiaxsDriIxFo363ARlaL2D591s-22CnIo8=",
    quote:
      " Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.",
  },
  {
    name: "Deepanshu Khare",
    position: "CTO, Tech Solutions",
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZW1wbG95ZWV8ZW58MHx8MHx8fDA%3D",
    quote:
      "Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.",
  },
  {
    name: "Vaishnvi Khurana",
    position: "Manager, Creative Co.",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZW1wbG95ZWV8ZW58MHx8MHx8fDA%3D",
    quote:
      " Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.",
  },
  {
    name: "Neha Patidar",
    position: "Founder, StartUpX",
    image:
      "https://cdn.pixabay.com/photo/2023/06/10/18/09/business-8054605_1280.jpg",
    quote:
      " Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.",
  },
  {
    name: "Sonam Singh",
    position: "Director, BuildPro",
    image:
      "https://cdn.pixabay.com/photo/2023/06/10/18/09/business-8054608_1280.jpg",
    quote:
      " Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.",
  },
  {
    name: "PushpRaj Verma",
    position: "Designer, Artify",
    image:
      "https://cdn.pixabay.com/photo/2023/06/10/07/18/business-8053376_1280.jpg",
    quote:
      "Eius ipsam praesentium dolor quaerat inventore rerum odio. Quos laudantium adipisci eius. Accusamus qui iste cupiditate sed temporibus est aspernatur. Sequi officiis ea et quia quidem.",
  },
];

export default function Testimonials() {
  return (
    <div
      className="testimonials-container"
      data-aos="fade-up"
      style={{ marginTop: "-25px" }}
    >
      {testimonials.map((t, index) => (
        <div key={index} className="testimonial-card">
          <div className="testimonial-header">
            <img src={t.image} alt={t.name} className="testimonial-img" />
            <div>
              <h4 className="testimonial-name">{t.name}</h4>
              <p className="testimonial-position">{t.position}</p>
            </div>
          </div>
          <div className="testimonial-stars">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="star">
                ★
              </span>
            ))}
          </div>
          <p className="testimonial-quote">“{t.quote}”</p>
        </div>
      ))}
    </div>
  );
}
